import { render, staticRenderFns } from "./CreateStoreCustomer.vue?vue&type=template&id=67c79fdc"
import script from "./CreateStoreCustomer.vue?vue&type=script&lang=js"
export * from "./CreateStoreCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports